export type TrackingParameterValue = string | number | undefined | boolean;

export enum InteractionEvent {
  PageView = 'virtual_pageview',
  HeaderInteraction = 'header_interaction',
  FooterInteraction = 'footer_interaction',
  FavouritesShow = 'favourites_show',
  MarketMapInteraction = 'market_map_interaction',
  FeatureDisplayed = 'feature_displayed',
  ButtonClick = 'button_click',
}
